import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Toast, ListView } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import Empty from '../../components/common/Empty';

import '../../assets/scss/Notice/noticeHome.scss';
import SystemIcon from '../../assets/images/notice/admin_big@2x.png';
import TipIcon from '../../assets/images/notice/tip@2x.png';

class NoticeHome extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.state = {
      dataSource: dataSource, //列表初始化
      isLoading: true, //是否加载中
      initData: [], //总数据
      postData: {
        pageNumber: 1, //当前页数
        pageSize: 9, //每页个数
      },
      totalPage: 0, //总页数
      emptyData: false,
      tabArr: ['全部', '公共消息', '我的消息'],
      curIndex: 0,
      unreadCount: 0
    }
  }

  //触底加载
  onEndReached = () => {
    if (!this.state.isLoading) {
      return;
    }
    const postData = this.state.postData;
    postData.pageNumber++;
    this.setState({
      isLoading: true,
      postData: postData
    });
    this.fetchData()
  }

  componentDidMount() {
    this.fetchData();
    this.fetchCount();
  }

  fetchData = () => {
    let path = '';
    switch (this.state.curIndex) {
      case 0: 
        path = '/spread/web/message/message/all';
        break;
      case 1: 
        path = '/spread/web/message/notice/list';
        break;
      case 2: 
        path = '/spread/web/message/user/message';
        break;
      default: 
        break;
    }
    Toast.loading('加载中，请稍后...', 0.5, async () => {
      const res = await Http.post(path, this.state.postData);
      if (res.code === 0) {
        Toast.hide();
        if (!res.data.content.length) {
          this.setState({
            emptyData: true,
            initData: []
          });
          return;
        }
        const list = res.data.content;
        this.state.initData = this.state.initData.concat([list]);
        this.setState({
          initData: this.state.initData,
          dataSource: this.state.dataSource.cloneWithRows(this.state.initData),
          isLoading: true,
          postData: this.state.postData,
          emptyData: false,
        });
        if (this.state.postData.pageNumber === res.data.totalPages || res.data.totalPages === 0) {
          this.setState({
            isLoading: false
          });
        }
      } else {
        Toast.fail(res.msg, 2);
      }
    });
  }

  fetchCount = async () => {
    const path = '/spread/web/message/unread/count';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        unreadCount: res.data.allUnreadCount,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //点击tab
  tabClick = (index) => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    this.setState({
      curIndex: index,
      postData: postData,
      initData: []
    }, () => {
      this.fetchData();
    });
  }

  render () {
    const row = (rowData, sectionID, rowID) => {
      return (
        <ul>
          {
            rowData.map((item, index) => {
              return (
                <Link key={index} to={`/noticeDetail/${item.id}?type=${item.type}`}>
                  <li>
                    <div className='left'>
                      <img src={item.type === 0 ? SystemIcon : TipIcon} alt="" />
                      <i className={item.isRead === 0 ? 'read' : ''}></i>
                    </div>
                    <div className='right'>
                      <div className='right-top'>
                        <div className={item.type === 0 ? 'system' : ''}>{item.title}</div>
                        <div>{item.time}</div>
                      </div>
                      <div className='right-bottom noWrap'>{item.content}</div>
                    </div>
                  </li>
                </Link>
              )
            })
          }
        </ul>
      );
    };
    const { tabArr, curIndex } = this.state;
    return (
      <div>
        <Helmet><title>消息</title></Helmet>
        <div className='noticeHome'>
          <div className='tab'>
            <ul>
              {
                tabArr.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => this.tabClick(index)}
                      className={curIndex === index ? 'high' : ''}>
                      {item}{curIndex === index && <span></span>}
                      {((index === 0 && this.state.unreadCount > 0) || (index === 1 && this.state.noticeUnreadCount > 0)) && <i className='read'></i>}
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className='content'>
            {
              this.state.emptyData ? <Empty tip='暂无数据..' /> : <ListView
              ref={el => this.lv = el}
              dataSource={this.state.dataSource}
              renderFooter={() =>
                (<div style={{ textAlign: 'center', backgroundColor: '#fff' }}>
                  {this.state.isLoading ? 'loading...' : '已加载全部~'}
                </div>)}
              renderRow={row}
              style={{height: '12.34rem', overflow: 'auto'}}
              onEndReached={this.onEndReached}
              onEndReachedThreshold={10} />
            }
          </div>
        </div>
      </div>
    )
  }
}

export default NoticeHome;